// extracted by mini-css-extract-plugin
export default {"scoreRow":"Fd91R77klkWIc2BZKf1a","result":"SGyVsyitP4bIouTA6Bf8"};